import { BaseService } from "./BaseService";
import { Category } from "@/types/category";
import {
  ICategoryService,
  CategoryFilters,
  CreateCategoryDto,
  UpdateCategoryDto,
  CategoryFindAllResponse,
  ReorderDto,
} from "./interfaces/ICategoryService";

class CategoryService extends BaseService implements ICategoryService {
  private basePath = "/categories";

  constructor() {
    super();
  }

  async findAll(filters: CategoryFilters): Promise<CategoryFindAllResponse> {
    return this.get<CategoryFindAllResponse>(this.basePath, filters);
  }

  async create(data: CreateCategoryDto): Promise<Category> {
    return this.post<Category>(this.basePath, data);
  }

  async update(id: string, data: UpdateCategoryDto): Promise<Category> {
    return this.patch<Category>(`${this.basePath}/${id}`, data);
  }

  async deleteCategory(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }

  async reorder(data: ReorderDto): Promise<void> {
    return this.post<void>(`${this.basePath}/reorder`, data);
  }
}

export const categoryService = new CategoryService();
